import { useCallback, useEffect, useState } from 'react';
import { T } from '../components/text/TextEdit';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileSearch, Plus } from 'lucide-react';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Skeleton } from '../components/pipeline/ui';
import NewIdeaDialog from '../components/NewIdeaDialog';

// Path B's dashboard - the same shape Ideas / Market analyses / Build packs have, so the sidebar
// row the mock draws has somewhere to point.
//
// This does NOT redesign Path B. CLAUDE.md §0 parks it, and nothing here touches PathBStage, the
// report, the lanes or the prompts. It lists the reports that already exist and opens the screen
// that was already there.
//
// A Path B report is a project created through the Review door, so origin === 'review' is the
// filter. No new API action, no server change.
export default function PathBDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    api.listProjects()
      .then((ps) => setRows((ps || []).filter((p) => p.origin === 'review')))
      .catch(() => setFailed(true));
  }, []);
  useEffect(() => { load(); }, [load]);

  const head = (
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1 className="font-heading text-3xl font-bold"><T k="stepper.pathb" /></h1>
        <p className="mt-1 text-muted-foreground"><T k="pathB.subtitle" /></p>
      </div>
      <Button onClick={() => setOpen(true)} data-testid="new-pathb-button">
        <Plus className="me-2 h-4 w-4" /> {t('dashboard.newProject')}
      </Button>
    </div>
  );

  if (failed) return (<>{head}<p className="mt-6 text-muted-foreground"><T k="common.loadFailed" /></p></>);

  return (
    <>
      {head}
      {!rows ? (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Skeleton className="h-40 w-full" /><Skeleton className="h-40 w-full" /><Skeleton className="h-40 w-full" />
        </div>
      ) : rows.length === 0 ? (
        <p className="mt-6 text-muted-foreground" data-testid="pathb-empty"><T k="pathB.intakeHint" /></p>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="grid-pathb">
          {rows.map((p) => (
            <button
              key={p.id}
              type="button"
              className="flex flex-col rounded-lg border border-border bg-card p-5 text-start hover:border-primary"
              data-testid={`card-pathb-${p.id}`}
              onClick={() => navigate(`/project/${p.id}/pathb`)}
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-border">
                <FileSearch className="h-4 w-4 text-muted-foreground" />
              </span>
              <h3 className="mt-3 font-heading font-semibold" title={p.name || ''}>{p.name || '—'}</h3>
              <p className="mt-1 font-data text-xs text-muted-foreground">{new Date(p.created_at).toLocaleDateString()}</p>
            </button>
          ))}
        </div>
      )}
      <NewIdeaDialog open={open} onOpenChange={setOpen} only="review" />
    </>
  );
}